<script
  setup
  lang="ts"
  generic="
    ListingFilter extends {
      code: string;
      min?: number;
      max?: number;
      label: string;
    }
  "
>
import { useCmsTranslations } from "@shopware/composables";
import type { Schemas } from "#shopware";
import { onMounted, reactive, ref, watch } from "vue";
import { defu } from "defu";
import { onClickOutside, useDebounceFn } from "@vueuse/core";



const emits = defineEmits<{
  (e: "select-value", value: { code: string; value: unknown }): void;
}>();

const props = defineProps<{
  filter: ListingFilter;
  selectedFilters: Schemas["ProductListingResult"]["currentFilters"];
}>();

type Translations = {
  listing: {
    min: string;
    max: string;
  };
};
let translations: Translations = {
  listing: {
    min: "Min",
    max: "Max",
  },
};
translations = defu(useCmsTranslations(), translations) as Translations;

const prices = reactive<{ min: number; max: number }>({
  min: 0,
  max: 0,
});

onMounted(() => {
  prices.min = Math.floor(
    props.selectedFilters.price.min ?? props.filter?.min ?? 0,
  );
  prices.max = Math.floor(
    props.selectedFilters.price.max ?? props.filter?.max ?? 0,
  );
});

const dropdownElement = ref(null);

function onMinPriceChange(newPrice: number, oldPrice: number) {
  if (newPrice === oldPrice || oldPrice === 0) return;
  emits("select-value", {
    code: "min-price",
    value: newPrice,
  });
}
const debounceMinPriceUpdate = useDebounceFn(onMinPriceChange, 500);
watch(() => prices.min, debounceMinPriceUpdate);

function onMaxPriceChange(newPrice: number, oldPrice: number) {
  if (newPrice === oldPrice || oldPrice === 0) return;
  emits("select-value", {
    code: "max-price",
    value: newPrice,
  });
}
const debounceMaxPriceUpdate = useDebounceFn(onMaxPriceChange, 500);
watch(() => prices.max, debounceMaxPriceUpdate);

if(prices.min === 0) {
  prices.min = parseFloat(props.filter.min);
};

if(prices.max === 0) {
  prices.max = parseFloat(props.filter.max);
};

</script>

<template>
  <div class="mb-2 w-full">
    <h5 class="mb-[10px] md:mb-4 normal-case flex items-center justify-between">
      {{$t('filter.price')}}
    </h5>

    <transition name="fade" mode="out-in">
      <div class="mt-5">
        <div class="mt-2 block">
          <div class="slider-cont w-full">
            <SharedRangeSlider
                :min="props.filter.min"
                :max="props.filter.max"
                v-model:min-value="prices.min"
                v-model:max-value="prices.max"
            />
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: all 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
